import { Button, Modal, Form } from "react-bootstrap";
import React, { FormEvent, useRef, useState, useEffect } from "react";
import s from "./UsersItemList.module.css";
import { appAxiosInstance } from "../../../api";
import { toast } from "react-toastify";
import {Link} from "react-router-dom";

interface IUserResponse {
    id: number;
    name: string;
    email: string;
    linkPhoto: string;
    role: string;
    phoneNumber: string;
    registerDate: string;
    colorType: string;
    statusSubscribe: string;
    numberOfDayLogin: number;
    isFreePeriod: boolean;
}

interface IUsersItemProps {
    user: IUserResponse;
}

export function UsersItemList(
    { user}: IUsersItemProps) {
    const [showModal, setShowModal] = useState(false);

    const getStatusSubscribe = () => {

        if (user.isFreePeriod) {
            return "Пробный период"
        } else if (user.statusSubscribe === "CANCELED") {
            return "Подписка отменена"
        } else if (user.statusSubscribe === "SUBSCRIBER") {
            return "Подписка активна"
        } else {
            return "Нет подписки"
        }
    }

    const isSubscriber = user.isFreePeriod || user.statusSubscribe === "CANCELED" || user.statusSubscribe === "SUBSCRIBER";

    const handlePhotoClick = () => {
        if (user.linkPhoto) {
            setShowModal(true);
        }
    };

    return (
        <>
            <tr>
                <Link
                    to={`/user/${user.id}?isSubscriber=${isSubscriber}`}

                    className={s.rowLink}
                    target="_blank"
                >
                    <td>{user.id}</td>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{user.phoneNumber}</td>
                    <td>{user.registerDate}</td>
                </Link>
                <td>
                    {user.linkPhoto && (
                        <img
                            className={s.photoBlock}
                            onClick={handlePhotoClick}
                            src={user.linkPhoto}
                            alt="Thumbnail"
                        />
                    )}
                </td>
                <td>
                    {user.colorType}
                </td>
                <td>{user.numberOfDayLogin}</td>
                <td>{getStatusSubscribe()}</td>
            </tr>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Фото пользователя</Modal.Title>
                </Modal.Header>
                <Modal.Body className={s.modalBody}>
                    <div className={s.photoModalContainer}>
                        <img
                            src={user.linkPhoto}
                            alt="User photo"
                            className={s.photoModal}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Закрыть
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};